const UnauthorizedPage = () => (
  <div>
    <h1>403 - Unauthorized</h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default UnauthorizedPage;
